import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useLocation } from 'react-router';
import { Box, Stack, Typography, CircularProgress } from '@mui/material';
import { fileIndex } from '../../utils/fileIndex';

// Use the bundled worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfViewer() {
    const location = useLocation();
    const filepath = location.pathname.replace('/pdf/', ''); // e.g., 'resumes/test.pdf'

    const [metadata, setMetadata] = useState({});
    const [numPages, setNumPages] = useState(null);
    const [error, setError] = useState(null);

    // Load metadata
    useEffect(() => {
        const meta = fileIndex.find(item => {
            const itemPath = item.link.replace('/pdf/', '');
            return itemPath === filepath;
        });
        setMetadata(meta);
    }, [filepath]);

    // Called when PDF loads successfully
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <Stack sx={{ m: 10 }}>
            <Box
                sx={{
                    display: 'inline-block', // hug content
                    overflow: 'hidden', // ensures the PDF doesn't overflow the box
                    mx: 'auto' // center horizontally
                }}
            >
                {metadata?.name && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Typography color="#8c929b" fontSize={12} fontFamily="inherit">
                                {metadata.updated || ''}
                            </Typography>
                        </Stack>
                    </Box>
                )}
                {error ? (
                    <Typography color="red">Error: {error}</Typography>
                ) : (
                    <Document
                        file={`/${filepath}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={(err) => setError(err.message)}
                        loading={<CircularProgress />}
                    >
                        {Array.from(new Array(numPages), (el, index) => (
                            <Box
                                key={`page_${index + 1}`}
                                sx={{ mb: index < numPages - 1 ? 3 : 0 }} // gap between pages
                            >
                                <Page
                                    pageNumber={index + 1}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                />
                            </Box>
                        ))}
                    </Document>
                )}
            </Box>
        </Stack>
    );
}
